import React from "react";
import { ExitIcon } from "@radix-ui/react-icons";
import { Avatar, AvatarFallback, AvatarImage } from "components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "components/ui/dropdown-menu";

/**
 * Profile avatar + logout dropdown (regular authenticated nav only).
 */
const NavbarUserMenu = ({ variant, cityInfo, username, onLogout }) => {
  if (variant === "collapsed") {
    return (
      <div className="w-full flex flex-col justify-center absolute bottom-0">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              type="button"
              className="rounded-full p-2 flex justify-center hover:bg-[#e4e6e4] w-full"
              aria-label="User menu">
              <Avatar className="shadow-lg">
                <AvatarImage
                  src={cityInfo?.city_image}
                  alt=""
                />
                <AvatarFallback>CN</AvatarFallback>
              </Avatar>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-[200px]">
            <DropdownMenuItem onClick={onLogout}>
              <ExitIcon className="mr-2 h-4 w-4" />
              <span>Logout</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center mt-5">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="flex w-[200px] items-center justify-between hover:bg-[#e4e6e4] rounded-lg p-2 text-left"
            aria-label="User menu">
            <div className="flex gap-2 items-center min-w-0">
              <Avatar className="shadow-lg shrink-0">
                <AvatarImage
                  src={cityInfo?.city_image}
                  alt=""
                />
                <AvatarFallback>CN</AvatarFallback>
              </Avatar>
              <div className="flex flex-col items-start min-w-0">
                <span className="text-[#40423f] text-[15px] font-normal font-['Roboto'] leading-[18px] truncate w-full">
                  {cityInfo?.city_name}
                </span>
                <span className="text-[#8a8d89] text-[13px] font-normal font-['Roboto'] leading-none truncate w-full">
                  {username}
                </span>
              </div>
            </div>
            <img
              src="icons/userAction.svg"
              alt=""
              className="shrink-0"
            />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-[200px]">
          <DropdownMenuItem onClick={onLogout}>
            <ExitIcon className="mr-2 h-4 w-4" />
            <span>Logout</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default NavbarUserMenu;
